import React, { FC } from "react"
import GatsbyImage from "gatsby-image"
import styled from "styled-components"
import CustomPrismicTitle from "../atoms/CustomPrismicTitle"
import CustomRichText from "../atoms/CustomRichText"
import mq from "../../styles/breakpoints"
import { IStackColumnsContent } from "../../prismic-types/slices/stack-columns-content"

const StackColumnsContent: FC<IStackColumnsContent> = ({ items }) => {
  return (
    <Container>
      <StyledContentWrapper itemCount={items?.length}>
        {items.map((item, index) => (
          <Column
            key={`column-${index}`}
            aligned={
              index === 0
                ? "start"
                : index === Math.floor(items?.length / 2)
                ? "center"
                : "end"
            }
            itemCount={items?.length}
          >
            <ColumnContent>
              {item.title && (
                <ImageWrapper>
                  <GatsbyImage
                    alt={item.image.alt || ""}
                    fluid={item.image.fluid}
                  />
                </ImageWrapper>
              )}
              {item.title.length && <CustomPrismicTitle data={item.title} />}
              {item.description1.length && (
                <CustomRichText data={item.description1} />
              )}
            </ColumnContent>
          </Column>
        ))}
      </StyledContentWrapper>
    </Container>
  )
}

export default StackColumnsContent

const Container = styled.section``

const StyledContentWrapper = styled.div<{ itemCount: number }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 48px;
  gap: 48px;
  align-items: top;

  ${mq.from.M`
    grid-template-columns: repeat(${({ itemCount }: { itemCount: number }) =>
      itemCount}, 1fr)
  `};
`

const Column = styled.div<{ aligned: string; itemCount: number }>`
  display: grid;
  justify-items: start;
  align-content: space-between;

  ${mq.from.M`
    margin-top: ${({
      aligned,
      itemCount,
    }: {
      aligned: string
      itemCount: number
    }) => {
      if (itemCount === 2) {
        return aligned === "start" ? "0px" : "80px"
      }
      return aligned === "start"
        ? "0px"
        : aligned === "center"
        ? "80px"
        : aligned === "end"
        ? "160px"
        : "0px"
    }};
  `}
`

const ColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100%;
  gap: 20px;
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  order: 0;

  img {
    margin-bottom: 0;
    border-radius: 16px;
  }
`
